/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FboLocationMinimalResponse } from '../../models/fbo-location-minimal-response';
import { SwitchActiveFboLocationRequest } from '../../models/switch-active-fbo-location-request';

export interface SwitchFboLocation$Params {
      body: SwitchActiveFboLocationRequest
}

export function switchFboLocation(http: HttpClient, rootUrl: string, params: SwitchFboLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<FboLocationMinimalResponse>> {
  const rb = new RequestBuilder(rootUrl, switchFboLocation.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FboLocationMinimalResponse>;
    })
  );
}

switchFboLocation.PATH = '/api/me/fbo-locations';
